import { useMemo } from 'react';
import { User } from '../constants/user';

export const useIsGuest = user => useMemo(() => user?.status === User.statuses.Guest, [user]);
